// Third party
import React from 'react';
import { get } from 'lodash';

// Components
import { Link } from '@capintel/component-lib/link';

// Utils
import { formatLocalizedString, LOCALE } from '@/utils/i18n';
import User from '@/types/user';
import { getThemeVersion } from '@/utils/theme';

type Props = {
  user: User;
  compact?: boolean;
};

const LEGACY_PATH = {
  'en-CA': 'https://capintel-uploads.s3.ca-central-1.amazonaws.com/enterprise-logos/mackenzie-logo-link-en.svg',
  'en-US': 'https://capintel-uploads.s3.ca-central-1.amazonaws.com/enterprise-logos/mackenzie-logo-link-en.svg',
  'fr-CA': 'https://capintel-uploads.s3.ca-central-1.amazonaws.com/enterprise-logos/mackenzie-logo-link-fr.svg',
};

export default function LinkLogo(props: Props) {
  const { user, compact } = props;
  const { isLightVersion } = getThemeVersion(user);

  if (!user.appConfig.linkBranding?.image || Object.keys(user.appConfig.linkBranding.image).length === 0) {
    return null;
  }

  const locale = user.authUser.locale ?? LOCALE.EN_CA;
  const path = !isLightVersion ? { [locale]: LEGACY_PATH[locale] } : get(user.appConfig.linkBranding.image, compact ? 'sm' : 'lg');

  const formattedPath = formatLocalizedString(path);

  if (user.appConfig.linkBranding?.url != null) {
    return (
      <Link href={formatLocalizedString(user.appConfig.linkBranding?.url)} variant="subtle">
        <img src={formattedPath} alt={user.enterprise?.name} className="link-branding-logo" />
      </Link>
    );
  }

  return <img src={formattedPath} alt={user.enterprise?.name} className="link-branding-logo" />;
}
